// extracted by mini-css-extract-plugin
module.exports = {"timer-button":"TimerButton_timer-button__3cG1X","pressed":"TimerButton_pressed__3HcHg"};